import React from 'react'
import { createUseStyles } from 'react-jss'
import get from 'lodash/get'
import cn from 'classnames'
import YotpoReviews from '../YotpoReviews'
import theme from '../../style/theme'

const YotpoReviewsSlice = ({ slice, className, product }) => {
  const classes = useStyles()

  // Return early if no product is provided
  if (!product || !product.store) {
    console.warn('YotpoReviewsSlice: No product data provided')
    return null
  }

  // Extract data from slice
  const title = get(slice, 'title', 'Reviews')
  const showReviews = get(slice, 'showReviews', true)
  const customSettings = get(slice, 'settings', {})

  // If reviews are disabled in this slice, don't render
  if (!showReviews) {
    return null
  }

  // console.log('YotpoReviewsSlice: Rendering reviews for product:', product.store?.title)

  return (
    <div className={cn(classes.container, className)}>
      {/* Optional custom title if different from default */}
      {slice.title && slice.title !== 'Reviews' && (
        <div className={classes.titleSection}>
          <h2 className={classes.customTitle}>{title}</h2>
        </div>
      )}
      {/* YotpoReviews component */}
      <YotpoReviews
        product={product}
        customSettings={customSettings}
      />
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    width: '100%',
    margin: '0 auto'
  },
  titleSection: {
    textAlign: 'center',
    marginBottom: '2rem'
  },
  customTitle: {
    fontSize: '48px',
    fontFamily: theme.fonts.headings,
    fontWeight: theme.fonts.headingsFontWeight,
    color: theme.colors.primary,
    margin: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: '30px'
    }
  }
}, { name: 'YotpoReviewsSlice' })

export default YotpoReviewsSlice
